export default "__VITE_ASSET__Cq$4PHAd__"